var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vc-day-popover-row" }, [
    _vm.indicator
      ? _c("div", { staticClass: "vc-day-popover-row-indicator" }, [
          _c("span", { class: _vm.indicator.class, style: _vm.indicator.style })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vc-day-popover-row-content" },
      [
        _vm._t("default", [
          _vm._v(
            _vm._s(
              _vm.attribute.popover
                ? _vm.attribute.popover.label
                : "No content provided"
            )
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6ca2b12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6ca2b12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/v-calendar/components/PopoverRow.vue
// module id = null
// module chunks = 